import {AsyncPipe, NgClass} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger,} from '@angular/material/autocomplete';
import {MatIconButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {MatFormField, MatSuffix} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {kAfterRegex, kBeforeRegex} from '@app/assetfilter/filter.service';
import {Observable, of} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {Tag} from '../models';
import {TagService} from '../tag.service';

export class FilterQuery {
    value: string;
    search: boolean;
    date: boolean;
    user: boolean;
}

@Component({
    selector: 'frog-tag-input',
    templateUrl: './tag-input.component.html',
    styleUrls: ['./tag-input.component.scss'],
    imports: [
        MatInput,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        NgClass,
        MatFormField,
        MatAutocomplete,
        MatOption,
        MatIcon,
        MatIconButton,
        MatSuffix,
        AsyncPipe,
    ],
})
export class TagInputComponent implements OnInit {
    @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
    @Input() placeholder: string;
    @Input() categories: string[];
    @Input() excludeCategories: string[];
    @Input() actionPrefix: string;
    @Output() OnSelect: EventEmitter<FilterQuery>;

    public queryControl: UntypedFormControl;
    public filteredTags: Observable<Tag[]>;

    constructor(private tagService: TagService) {
        this.queryControl = new UntypedFormControl();
        this.OnSelect = new EventEmitter<FilterQuery>();
    }

    ngOnInit(): void {
        this.filteredTags = this.tagService.autocomplete('').pipe(
            mergeMap(() => {
                return this.queryControl.valueChanges;
            }),
            // debounceTime(150),
            mergeMap((value) => {
                if (typeof value === 'string' && Boolean(value)) {
                    return this.tagService.autocomplete(
                        value.toLocaleLowerCase(),
                        this.categories,
                        this.excludeCategories,
                    );
                }
                return of([]);
            }),
            map((tags) => {
                if (this.queryControl.value && this.actionPrefix) {
                    const actionTag = new Tag();
                    actionTag.id = null;
                    actionTag.name = `${this.actionPrefix} ${this.queryControl.value}`;
                    tags.splice(0, 0, actionTag);
                }

                return tags;
            }),
        );
    }

    clear() {
        this.queryControl.reset();
    }

    selectHandler(event: MatAutocompleteSelectedEvent) {
        this.emitSelect(event.option.value);
    }

    displayName() {
        return (tag) => (tag ? tag.displayName : null);
    }

    private emitSelect(tag: Tag) {
        const filterQuery = new FilterQuery();
        if (tag.id === null) {
            const queryValue = this.queryControl.value.name.replace(`${this.actionPrefix} `, '');
            filterQuery.value = queryValue;
            if (kAfterRegex.test(queryValue) || kBeforeRegex.test(queryValue)) {
                filterQuery.date = true;
            } else {
                filterQuery.search = true;
            }
        } else {
            filterQuery.value = tag.name;
            filterQuery.search = false;
        }
        this.OnSelect.emit(filterQuery);
        this.queryControl.setValue('');
    }
}
